import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('partMngPopupStore', Object.keys(getters)),
	...mapState('partMngPopupStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('partMngPopupStore', Object.keys(actions)),
	...mapMutations('partMngPopupStore', Object.keys(mutations))
};
